import MainTabs from "components/UI/organisms/MainTabs";
import ManageWrapper from "components/UI/organisms/ManageWrapper";
import { COMPONENT_TYPES } from "helpers/utils/constants";
import React, { useEffect, useState } from "react";
import ApplicationsLiting from "./listings/ApplicationsLiting";
import JobsListing from "./listings/JobsListing";
import useFilters, { FILTER_TYPES } from "helpers/hooks/useFilters";
import { useSearchParams } from "react-router-dom";
import useRedirect from "helpers/hooks/useRedirect";
import useJobNetwork from "store/job-network";
import { APPLICATION_STATUS, JOB_STATUS } from "./forms/data";
import { useLocalizedTranslation } from "helpers/hooks/useLocalizedTranslation";
import EmptyText from "components/UI/atoms/EmptyText";
import useListingHeader from "helpers/hooks/useListingHeader";
import ListingPageHeader from "components/UI/organisms/ListingPageHeader";
import MasterSelect from "components/UI/organisms/MasterSelect";
import { hasFiltersApplied } from "helpers/utils/utilities";

const ManageJobNetwork = () => {
  const [tab, setTab] = useState(0);
  const [browseMode, setBrowseMode] = useState(0);
  const { gridType, setGridType, search, setSearch } = useListingHeader();
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const { navigateCreateJob } = useRedirect();
  let [searchParams, setSearchParams] = useSearchParams();
  // const searchTab = searchParams.get("tab");
  const { fetchJobs, fetchApplications, updateApplicationStatus, deleteJob } =
    useJobNetwork();
  const [loading, setLoading] = useState(true);
  const [jobs, setJobs] = useState([]);
  const [job, setJob] = useState(null);
  const [applications, setApplications] = useState([]);
  const { t } = useLocalizedTranslation("common");
  const { selected } = useFilters();

  useEffect(() => {
    if (tab !== 1 && jobs?.length) return;
    handleFetchJobs();
  }, [search, tab, browseMode, selected, page]);

  useEffect(() => {
    if (tab !== 0 || !job || !job?.key) return;
    handleFetchApplications();
  }, [job, search, browseMode, page]);

  const handleFetchJobs = async () => {
    setLoading(true);
    const filters = {
      search,
      status: JOB_STATUS[+browseMode]?.key,
      page,
      ...selected,
    };
    const res = await fetchJobs(filters);
    setJobs(res?.list || []);
    if (res?.list?.length && !job)
      setJob({ key: res?.list[0]?.uuid, value: res?.list[0]?.title });
    if (page > res?.total_pages) setPage(res?.total_pages);
    setPages(res?.total_pages || 0);
    if (tab === 1) setTotalCount(res?.total_count);
    setLoading(false);
  };

  const handleFetchApplications = async () => {
    setLoading(true);
    const filters = {
      search,
      status: APPLICATION_STATUS()[+browseMode]?.key,
      page,
    };
    const res = await fetchApplications(job?.key, filters);
    setApplications(res?.list || []);
    if (page > res?.total_pages) setPage(res?.total_pages);
    setPages(res?.total_pages || 0);
    if (tab === 0) setTotalCount(res?.total_count);
    setLoading(false);
  };

  // useEffect(() => {
  //   if (searchTab) {
  //     setTab(+searchTab);
  //   }
  // }, [searchTab]);

  const handleChangeTab = (i) => {
    // searchParams.set("tab", i);
    setTab(i);
    if (page !== 1) setPage(1);
    if (browseMode !== 0) {
      setBrowseMode(0);
      searchParams.set("browseMode", 0);
      setSearchParams(searchParams);
    }
  };

  const handleUpdateApplicationStatus = (e) => {
    const newStatus = e.target.value;
    const applicationId = e.target.name;
    updateApplicationStatus(applicationId, newStatus);
    setApplications((prev) =>
      prev.map((d) => ({
        ...d,
        status: d?.id === applicationId ? newStatus : d?.status,
      }))
    );
  };

  const handleDeleteJob = async (uuid) => {
    await deleteJob(uuid);
    setJobs((prev) => prev.filter((d) => d?.uuid !== uuid));
  };

  return (
    <ManageWrapper
      browseMode={browseMode}
      setBrowseMode={setBrowseMode}
      component={COMPONENT_TYPES.JOB_NETWORK}
      pageTitle="Job Network"
      hidePlan
      hideFilters={tab === 0}
      filters={[
        FILTER_TYPES.DATE_POSTED,
        FILTER_TYPES.WORK_MODE,
        FILTER_TYPES.EXPERIENCE_LEVEL,
        FILTER_TYPES.JOB_TYPE,
      ]}
      hideSearchSort
      createActionTitle="Create Job"
      navigateCreate={navigateCreateJob}
      browseOptions={tab === 0 ? APPLICATION_STATUS() : JOB_STATUS}
      hideOnSeedPlan={!loading}
    >
      <MainTabs
        tabs={["Applicant Management", "Job Management"]}
        current={tab}
        setCurrent={handleChangeTab}
      />
      <ListingPageHeader
        gridType={gridType}
        setGridType={setGridType}
        search={search}
        setSearch={setSearch}
        noCard
        noSort={tab === 1}
        selectContent={
          <MasterSelect
            name="job_id"
            classes="w-100p mr-2"
            width="100%"
            value={job}
            onChange={(e) => setJob(e.target.value)}
          />
        }
        classes="my-3"
        hideSearchButton
        searchInputHeight="40px"
        leftMd={tab === 0 ? 7 : null}
      />
      {totalCount && !loading ? (
        <h4 className="mt-4">
          {totalCount} {t("Results", "common")}
        </h4>
      ) : null}
      {tab === 0 ? (
        <ApplicationsLiting
          applications={applications}
          loading={loading}
          gridType={gridType}
          handleUpdateApplicationStatus={handleUpdateApplicationStatus}
          emptyView={
            <EmptyText>
              {hasFiltersApplied(selected) || Boolean(search)
                ? "No Results Found!"
                : t(
                    "Applicants that have applied to your Job will show up here."
                  )}
            </EmptyText>
          }
        />
      ) : (
        <JobsListing
          jobs={jobs}
          loading={loading}
          page={page}
          pageCount={pages}
          setPage={setPage}
          gridType={gridType}
          deleteJob={handleDeleteJob}
          manage
          emptyView={
            <EmptyText>
              {hasFiltersApplied(selected) || Boolean(search)
                ? t("No Results Found!", "common")
                : browseMode === 2
                ? t(
                    "Draft jobs you have created will show up here. Create your first draft job today!"
                  )
                : t(
                    "Jobs you have posted will show up here. Create your first job today!"
                  )}
            </EmptyText>
          }
        />
      )}
    </ManageWrapper>
  );
};

export default ManageJobNetwork;
